import React from 'react';
import ConceptTreeNode from './ConceptTreeNode';
import snakeToPascal from '../../tools';

// Recursive search match: item matches if its name/type/field names match,
// or if any descendant matches
export const isMatchSearchString = (item: any, tree: any, searchString: string): boolean => {
    if (!searchString) return true;
    const lower = searchString.toLowerCase();

    if (item.name.toLowerCase().includes(lower)) return true;
    if (item.type && item.type.toLowerCase().includes(lower)) return true;
    if (searchString.startsWith('#') && searchString.slice(1) === item.id) return true;

    for (const key of Object.keys(item.fields || {})) {
        if (snakeToPascal(key).toLowerCase().includes(lower)) return true;
    }

    return (item.childrens || []).some((id: string) =>
        tree.items[id] && isMatchSearchString(tree.items[id], tree, searchString)
    );
};

interface ConceptTreeProps {
    itemIds: string[];
    tree: { items: Record<string, any>; rootId: string };
    selectedItemId: string | null;
    onSelectItem: (id: string) => void;
    level: number;
    searchString: string;
    currentEntity?: any;
}

export default function ConceptTree({
    itemIds,
    tree,
    selectedItemId,
    onSelectItem,
    level,
    searchString,
    currentEntity,
}: ConceptTreeProps) {
    return (
        <>
            {itemIds.map((id) => {
                const item = tree.items[id];
                if (!item) return null;
                if (searchString && !isMatchSearchString(item, tree, searchString)) return null;
                return (
                    <ConceptTreeNode
                        key={id}
                        item={item}
                        tree={tree}
                        selectedItemId={selectedItemId}
                        onSelectItem={onSelectItem}
                        level={level}
                        searchString={searchString}
                        isMatchSearch={isMatchSearchString}
                        currentEntity={currentEntity}
                    />
                );
            })}
        </>
    );
}
